/** Shared layout tokens for web/desktop */
export const WEB_CONTENT_MAX_WIDTH = 1200;
/** Sign-in / sign-up card on web auth split layout */
export const WEB_AUTH_CARD_MAX_WIDTH = 560;
export const WEB_AUTH_CARD_MIN_HEIGHT = 520;
/** Fixed width for green brand column on auth screens (welcome, login, etc.) */
export const WEB_AUTH_BRAND_PANEL_WIDTH = 360;
export const WEB_AUTH_BRAND_MAX_WIDTH_PERCENT = 38;
export const WEB_CONTENT_PADDING_H = 24;
export const WEB_CONTENT_PADDING_V = 16;

export const webContentContainerStyle = {
  width: '100%' as const,
  maxWidth: WEB_CONTENT_MAX_WIDTH,
  alignSelf: 'center' as const,
  paddingHorizontal: WEB_CONTENT_PADDING_H,
  paddingBottom: 32,
};

